import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { MainEntitiesProvider, UserAuth } from '@nrwl/common-lib';

@Injectable({
  providedIn: 'root'
})
/**
 * Detects whether this is browser reload event (eg, user pressed F5) and makes sure
 * to load entities cache before the route is activated.
 *
 * Does nothing when copy+pasting URL (because this guard is fired twice: first when browser
 * refresh is detected - but there is no token to auth against backend!; second after sign
 * in - but then it is no longer recognized as 'refresh')
 */
export class RefreshEntityCacheGuard implements CanActivate {
  constructor(
    public router: Router,
    public userAuth: UserAuth,
    readonly mainEntities: MainEntitiesProvider
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isShared = JSON.parse(sessionStorage.getItem('isShared'));
    const browserRefresh = !this.router.navigated;
    if ((browserRefresh && this.hasUserToken()) || (isShared && this.hasUserToken())) {
      this.mainEntities.reloadEntities();
    }

    return Promise.resolve(true);
  }

  hasUserToken(): boolean {
    const user = sessionStorage.getItem(this.userAuth.STORAGE_KEY);
    if (user) {
      const userJson = JSON.parse(user);
      if (userJson.token) {
        return true;
      }
    }
    return false;
  }
}
